import React, { Component } from "react";
import { ErrorContainer, ErrorAlign, ErrorText, ErrorDump } from "../styledComponents";
import alert from '../assets/alert.svg';

class ErrorSplash extends Component {

  _getErrorMessage(environment) {
    if (environment === 'prd') return 'There was an error starting chat. We apologize, please close this window and try again';

    return `There was an error mounting the chat widget in ${environment} environment. Please see the error log below:`;
  }

  render() {
    const { errMessage, environment} = this.props;
    return (
      <ErrorContainer>
        <ErrorAlign>
            <img src={alert} alt='Error'/>
          <ErrorText>{this._getErrorMessage(environment)}</ErrorText>
          <ErrorDump>{(environment !== 'prd') && errMessage}</ErrorDump>
        </ErrorAlign>
      </ErrorContainer>
    );
  }
}

export default ErrorSplash;